var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 23.201C5.896 23.201.923 18.227.923 12.244c0-5.994 4.963-10.957 10.946-10.957 5.994 0 10.968 4.963 10.968 10.957 0 5.983-4.963 10.957-10.957 10.957zm0-1.826c5.07 0 9.13-4.06 9.13-9.13 0-5.071-4.07-9.132-9.14-9.132-5.071 0-9.11 4.06-9.11 9.131 0 5.07 4.05 9.131 9.12 9.131zm-.226-6.907c-.548 0-.86-.29-.86-.849v-.14c0-1.052.581-1.622 1.354-2.159.935-.655 1.386-1.01 1.386-1.74 0-.816-.634-1.375-1.611-1.375-.72 0-1.278.365-1.654.988l-.194.258c-.193.258-.43.43-.795.43a.719.719 0 0 1-.73-.741c0-.183.032-.355.086-.527.29-.988 1.504-1.869 3.351-1.869 1.826 0 3.416.967 3.416 2.75 0 1.29-.74 1.912-1.783 2.6-.752.494-1.096.88-1.096 1.482v.13c0 .418-.333.762-.87.762zm-.021 3.2c-.623 0-1.16-.504-1.16-1.116 0-.612.526-1.117 1.16-1.117.634 0 1.16.494 1.16 1.117s-.537 1.117-1.16 1.117z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e0c0c140523bb5ab8f749314308247b0.svg";
export { ForwardRef as ReactComponent };